import React from 'react';
import { string, shape, bool } from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { connect, Provider } from 'react-redux';

import { Loader } from '@tesla/design-system-react';
import { SiteFooter } from '@tesla/tw-react';
import { TtpProvider } from '~/shared/components/TtpContent';
import Content from './pages';
import Selectors from './common/redux/selectors';

import '@tesla/design-system/dist/index.css';
import './css/reset.css';
import '@tesla/tw-react/dist/index.css';

import styles from './App.module.css';

const propTypes = {
  store: shape({}).isRequired,
  ttp: shape({}).isRequired,
  initialData: shape({}).isRequired,
  baseRoute: string.isRequired,
  showLoader: bool,
  hideBackground: bool,
};

const defaultProps = {
  showLoader: false,
  hideBackground: false,
};

const App = ({ store, ttp, baseRoute, showLoader, hideBackground, initialData }) => {
  const { locale } = initialData;
  return (
    <Provider store={store}>
      <TtpProvider value={ttp}>
        <div className={styles.AppWrapper}>
          <BrowserRouter basename={baseRoute}>
            <div
              className={`${styles.OpaqueScrim}${
                hideBackground ? ` ${styles.OpaqueScrimShow}` : ''
              }`}
            />
            <div className={styles.Loader}>
              <Loader fullscreen show={showLoader} />
            </div>
            <Content />
          </BrowserRouter>
        </div>
        <SiteFooter locale={locale} />
      </TtpProvider>
    </Provider>
  );
};
App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default connect(Selectors)(App);
